// react components
import React from 'react'
import PhoneInput from 'react-phone-number-input'
import {
    useDispatch,
} from 'react-redux'

// styles
import 'react-phone-number-input/style.css'

// data
import {
    reduxModalErrorEventHandlerSite,
} from 'data'

// pages
import {
    ErrorHelper825,
    FormLabel825,
} from 'pages'

// props
type PhoneNumberInputV2825Props = {
    disabled?: boolean
    error?: string
    helperText?: string
    label?: string
    name: string
    onChange: any
    onRefresh?: () => void
    value: any
}

// main
export const PhoneNumberInputV2825: React.FC<PhoneNumberInputV2825Props> = React.memo(({
    disabled,
    error,
    helperText,
    label,
    name,
    onChange,
    onRefresh,
    value,
}) => {

    const dispatch = useDispatch()

    function onInputChange(value: string) {
        try {
            onChange({
                name: name,
                value: value,
            })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'PhoneNumberInputV2825',
                'onInputChange',
            ))
        }
    }

    if (label) {
        return (
            <div className={`input-wrap-825${disabled ? ' disabled' : ''}`}>
                <div className='input-label-wrap'>
                    <FormLabel825
                        formInput='text'
                        helperText={helperText}
                        label={label || ''}
                        name={name}
                        onRefresh={onRefresh}
                        translationDefaultValue={value}
                    />
                </div>
                <div className='phone-number-input-825'>
                    <PhoneInput
                        defaultCountry='FR'  // TODO dynamic
                        disabled={disabled}
                        //@ts-ignore
                        onChange={onInputChange}
                        value={value || ''}
                    />
                </div>
                <ErrorHelper825 error={error} />
            </div>
        )
    }

    return (
        <div className='phone-number-input-825'>
            <PhoneInput
                defaultCountry='FR'  // TODO dynamic
                disabled={disabled}
                //@ts-ignore
                onChange={onInputChange}
                value={value || ''}
            />
        </div>
    )
})
